export default __webpack_public_path__ + "static/media/hook.f5c01779.png";